import { cn } from "@/common/utils/css.utils";
import { useProductCard } from "@/features/search/components/product-card/product-card.context";

/** Product title, clamped to two lines. */
export const ProductCardTitle = ({ className }: { className?: string }) => {
  const { product } = useProductCard();
  return (
    <h3
      className={cn(
        "line-clamp-2 font-body text-sm text-black md:text-base",
        className
      )}
    >
      {product.title}
    </h3>
  );
};
